import { I18n } from '@calendly/i18n';
import { Button } from '@calendly/ui/components/button';
import { IconCircleCheckFilled } from '@calendly/ui/components/glyphs/IconCircleCheckFilled';
import { IconLink } from '@calendly/ui/components/glyphs/IconLink';
import { MailSendEnvelopeIcon, CalendarAddIcon } from '@calendly/ui/components/icons';
import { BodyText } from '@calendly/ui/components/typography';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import { colorTextAction } from '@calendly/ui/theme';
import classNames from 'classnames';
import { useCallback, useEffect, useRef, useState } from 'react';
import { useFFTrackingV2 } from 'hooks/analytics_events/use_ff_tracking_v2';
import { CardButton } from './elements/card_button';
import { Footer } from './elements/footer';
import { PopupBody } from './elements/popup_body';
import { Header } from './elements/popup_header';
import { RescheduleFlowModal } from './reschedule_flow_modal';
const COPIED_RESET_MS = 3000;
const actionsRowCss = "a1xw8ef1";

/* Phone: stack so "Copy rescheduling link" stays on one line instead of wrapping mid-word. */
const actionsRowIsPhoneCss = "a142tbuv";
const fullWidthButtonCss = "f1i1uava";

/** Figma: colorTextSuccess / colorIconSuccess on the copied ghost button state. */
const copiedButtonCss = "c1l5pwwn";
export const SelectRescheduleMethodPopup = ({
  eventType,
  invitee,
  isInviteeOnlyReschedule,
  isOpen,
  onClose,
  onReschedule,
  onShare,
  rescheduleLink
}) => {
  useFFTrackingV2('host_reschedule_invitee_experience');
  const isPhone = useDeviceType('isPhone');
  const [isCopied, setIsCopied] = useState(false);
  const copiedTimeoutRef = useRef(null);
  useEffect(() => () => {
    if (copiedTimeoutRef.current) {
      clearTimeout(copiedTimeoutRef.current);
    }
  }, []);
  useEffect(() => {
    if (!isOpen) {
      setIsCopied(false);
      if (copiedTimeoutRef.current) {
        clearTimeout(copiedTimeoutRef.current);
        copiedTimeoutRef.current = null;
      }
    }
  }, [isOpen]);
  const handleCopyLink = useCallback(async () => {
    if (!rescheduleLink) return;
    try {
      await navigator.clipboard.writeText(rescheduleLink);
      setIsCopied(true);
      if (copiedTimeoutRef.current) {
        clearTimeout(copiedTimeoutRef.current);
      }
      copiedTimeoutRef.current = setTimeout(() => {
        setIsCopied(false);
        copiedTimeoutRef.current = null;
      }, COPIED_RESET_MS);
    } catch {
      // Clipboard may be unavailable in some environments
    }
  }, [rescheduleLink]);
  return <RescheduleFlowModal isOpen={isOpen} onClose={onClose} withCloseButton ariaLabel={isInviteeOnlyReschedule ? I18n.t('publisher.rescheduling_flow.title_invitee') : I18n.t('publisher.rescheduling_flow.title')}>
      <Header invitee={invitee} eventType={eventType} isInviteeOnlyReschedule={isInviteeOnlyReschedule} />
      <PopupBody>
        <BodyText weight="bold">
          {isInviteeOnlyReschedule ? I18n.t('publisher.rescheduling_flow.share_or_reschedule_modal.subtitle_invitee') : I18n.t('publisher.rescheduling_flow.share_or_reschedule_modal.subtitle')}
        </BodyText>
        <CardButton icon={<MailSendEnvelopeIcon size="x-large" color={colorTextAction} />} header={I18n.t('publisher.rescheduling_flow.share_or_reschedule_modal.share_card.title')} body={isInviteeOnlyReschedule ? I18n.t('publisher.rescheduling_flow.share_or_reschedule_modal.share_card.body_invitee', {
        invitee_name: invitee.name
      }) : I18n.t('publisher.rescheduling_flow.share_or_reschedule_modal.share_card.body')} onClick={onShare} />
        <CardButton icon={<CalendarAddIcon size="x-large" color={colorTextAction} />} header={isInviteeOnlyReschedule ? I18n.t('publisher.rescheduling_flow.share_or_reschedule_modal.book_card.title_invitee', {
        invitee_name: invitee.name
      }) : I18n.t('publisher.rescheduling_flow.share_or_reschedule_modal.book_card.title')} body={isInviteeOnlyReschedule ? I18n.t('publisher.rescheduling_flow.share_or_reschedule_modal.book_card.body_invitee', {
        invitee_name: invitee.name
      }) : I18n.t('publisher.rescheduling_flow.share_or_reschedule_modal.book_card.body')} onClick={onReschedule} />
      </PopupBody>
      <Footer>
        <div className={classNames(actionsRowCss, {
        [actionsRowIsPhoneCss]: isPhone
      })} data-testid="reschedule-method-actions" data-layout={isPhone ? 'stacked' : 'row'}>
          {rescheduleLink && <Button appearance="ghost" size="medium" label={isCopied ? I18n.t('publisher.action.copied_to_clipboard') : I18n.t('publisher.rescheduling_flow.share_or_reschedule_modal.copy_link')} leadingIcon={isCopied ? IconCircleCheckFilled : IconLink} onClick={handleCopyLink} className={classNames({
          [copiedButtonCss]: isCopied,
          [fullWidthButtonCss]: isPhone
        })} data-testid="copy-rescheduling-link" />}
          <Button appearance="secondary-outline" size="medium" label={I18n.t('publisher.action.done')} onClick={onClose} className={classNames({
          [fullWidthButtonCss]: isPhone
        })} data-testid="reschedule-method-done" />
        </div>
      </Footer>
    </RescheduleFlowModal>;
};

require("./select_reschedule_method_popup.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./select_reschedule_method_popup.js");